// Desktop/touch mega-panel handling (hover/focus/click swap).
export function setupPanels(navElement, state, desktopQuery, isTouchNav = false) {
  const navItems = navElement.querySelectorAll(".mega-nav__link");
  const panels = navElement.querySelectorAll(".mega-nav__panel");
  const searchPanel = navElement.querySelector(".mega-nav__search-panel");

  const setActivePanel = (target) => {
    state.activePanel = target;
    navItems.forEach((btn) => {
      const hasPanel = btn.dataset.hasPanel !== "false";
      btn.classList.toggle(
        "mega-nav__link--active",
        hasPanel && target && btn.dataset.target === target
      );
    });
    panels.forEach((panel) => {
      panel.classList.toggle(
        "mega-nav__panel--active",
        target && panel.dataset.panel === target
      );
    });
    if (target !== "search" && searchPanel) {
      searchPanel.classList.remove("mega-nav__search-panel--open");
      searchPanel.setAttribute("aria-hidden", "true");
    }
  };

  // Initial state
  setActivePanel(state.activePanel || null);

  // Hover / focus / click to swap desktop mega panels
  navItems.forEach((btn) => {
    const target = btn.dataset.target;
    const hasPanelFlag = btn.dataset.hasPanel || "true";
    const hasPanel = hasPanelFlag !== "false";
    const isInfoOnly = hasPanelFlag === "info";

    // Non-panel links should close any open panel on hover/focus.
    if (!hasPanel) {
      btn.addEventListener("focus", () => setActivePanel(null));
      btn.addEventListener("mouseenter", () => {
        if (desktopQuery.matches && !isTouchNav) setActivePanel(null);
      });
      return;
    }

    btn.addEventListener("click", () => {
      if (isTouchNav) {
        const isSame = state.activePanel === target;
        setActivePanel(isSame ? null : target);
      } else {
        // For info-only links we still allow navigation; the panel opens via hover/focus.
        if (!isInfoOnly) {
          setActivePanel(target);
        }
      }
    });
    btn.addEventListener("focus", () => setActivePanel(target));
    btn.addEventListener("mouseenter", () => {
      if (desktopQuery.matches && !isTouchNav) setActivePanel(target);
    });
  });

  return { setActivePanel };
}
